<template>
    <section class='viewsrhwxDriver_ContinueInPlantOperation'>
        <!-- <van-empty v-if="listData.length == 0" image="search" :description="description" /> -->
        <Empty v-if="listData.length == 0" class="empty-div" ></Empty>
        <div v-else class="card" v-for="(item, index) in listData" :key="index">
            <div class="card-item" v-for="(name, key) in listDataMap" :key="key">
                <span class="name" align="right">{{ name }}：</span>
                <span class="content">{{ item[key] || '--' }}</span>
            </div>
            <van-row type="flex" justify="end">
                <van-col>
                    <van-button @click="handleContinue(item.id)" style="font-size: 14px;" type="primary" size="small">继续作业</van-button>
                </van-col>
            </van-row>
        </div>
    </section>
</template>

<script>
import { Dialog } from 'vant';
import Empty from "@/components/tips/Empty.vue";
export default {

props:[''],

data () {
    return {
        url: {
            list: '/api/queue/driver/query_book',
            continue: '/api/queue/driver/continue_operation'
        },
        listData: [],
        listDataMap: {
            license_plate: '车牌号',
            business_name: '业务办理',
            sub_business: '子业务',
            company_name: '办理地点',
            name: '司机姓名',
            contact: '联系方式',
            time_range: '预约时间段'
        },
        booking_id: '',
        description: "暂无数据"
    };
},

computed: {},

watch: {},

components: {
    Empty
},

 mixins:[],

beforeCreate(){
    document.title = "继续厂内作业";
},

created(){
    this.getList()
},

beforeMount(){},

mounted(){},

activated(){},

deactivated(){},

 methods: {
    handleContinue(id) {
        this.booking_id = id;
        Dialog.confirm({
            title: '确认继续装车？',
            beforeClose: this.beforeClose,
            confirmButtonColor: "#009967"
        });
    },
    async beforeClose(action, done) {
        if (action === "confirm") {
            this.$common.http({
                url: this.url.continue,
                data: {
                    report_id: this.$route.query.report_id,
                    booking_id: this.booking_id
                }
            }).then((dataObj) => {
                if (dataObj.data.errcode == 0) {
                    this.getList();
                } else {
                    this.handleClosed(dataObj.data.errmsg);
                }
            })
        } 
        done();
    },
    handleClosed(msg) {
        this.$common.mbToastFail(msg);
    },
    // 获取继续厂内作业的预约单列表
    getList() {
        this.$common.http({
            url: this.url.list,
            data: {
                report_id: this.$route.query.report_id
            }
        }).then((dataObj) => {
            if (dataObj.data.errcode == 0) {
                this.listData = dataObj.data.data.map((item) => {
                    return {
                        ...item,
                        time_range: !(item.booking_being_time && item.booking_end_time) ? '' : `${item.booking_being_time} ~ ${item.booking_end_time}`, // 预约时间段
                        sub_business: item.sub_business.map((e) => {
                            return e.name
                        }).join(';'), // 子业务线
                    }
                })
            }
        }).catch(() => {
            // this.description = err.data.errmsg
        })
    }
 },

}

</script>
<style lang='less' scoped>
.empty-div {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.viewsrhwxDriver_ContinueInPlantOperation{
    width: 100%;
    height: 100vh;
    background: #f4f5f6;
    overflow-y: auto;
    box-sizing: border-box;
    padding-bottom: calc(15px + env(safe-area-inset-bottom));
    .card {
        width: 100%;
        background-color: #FFFFFF;
        padding: 16px;
        box-sizing: border-box;
        font-size: 16px;
        line-height: 30px;
        margin-bottom: 16px;
        .card-item {
            display: flex;
            align-items: center;
        }
        .name {
            color: #999999;
            display: inline-block;
            width: 6em;
        }
        .name[align="right"] {
            text-align: right;
            padding-right: 5px;
        }
        .content {
            color: #000000;
        }
    }
}
</style>